(() => {
  const dialog = document.getElementById('AfCardQuantity');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const input = dialog.querySelector('input');
  const minus = dialog.querySelector('[data-af-quantity-minus]');
  const plus = dialog.querySelector('[data-af-quantity-plus]');
  const confirmedForms = new WeakSet();
  let pendingForm;
  let pendingButton;
  let previousOverflow;

  const updateButtons = () => {
    const value = Number(input.value);
    minus.disabled = value <= Number(input.min);
    plus.disabled = input.max !== '' && value >= Number(input.max);
  };

  // Capture before the theme's ProductForm handler; confirmed submissions use it unchanged.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (confirmedForms.delete(form)) return;
    if (!window.matchMedia('(max-width: 767.98px)').matches) return;
    const quantity = form.querySelector('[data-af-card-quantity]');
    if (!quantity || !form.closest('.product-card')) return;
    const button = event.submitter || form.querySelector('[type="submit"]');
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true' || dialog.open) return;

    pendingForm = form;
    pendingButton = button;
    input.min = quantity.dataset.min || '1';
    input.step = quantity.dataset.step || '1';
    input.max = quantity.dataset.max || '';
    input.value = input.min;
    dialog.querySelector('[data-af-quantity-title]').textContent = quantity.dataset.productTitle;
    dialog.querySelector('[data-af-quantity-price]').textContent = quantity.dataset.productPrice;
    const image = dialog.querySelector('[data-af-quantity-image]');
    image.hidden = !quantity.dataset.productImage;
    if (!image.hidden) image.src = quantity.dataset.productImage;
    else image.removeAttribute('src');
    updateButtons();
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
    input.focus();
    input.select();
  }, true);

  minus.addEventListener('click', () => { input.stepDown(); updateButtons(); });
  plus.addEventListener('click', () => { input.stepUp(); updateButtons(); });
  input.addEventListener('input', updateButtons);
  dialog.querySelector('[data-af-quantity-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (dialog.open) return;
    document.documentElement.style.overflow = previousOverflow;
    pendingForm = null;
    pendingButton = null;
  });
  dialog.querySelector('[data-af-quantity-confirm]').addEventListener('submit', (event) => {
    event.preventDefault();
    if (!input.reportValidity() || !pendingForm?.isConnected || !pendingButton?.isConnected) return;
    const form = pendingForm;
    const button = pendingButton;
    form.querySelector('[data-af-card-quantity]').value = input.value;
    confirmedForms.add(form);
    // Close first so the existing cart drawer can open without two competing focus traps.
    dialog.close();
    document.documentElement.style.overflow = previousOverflow;
    form.requestSubmit(button);
    confirmedForms.delete(form);
  });
})();
